"use client"

import Link from "next/link"
import { ArrowRight, Sparkles } from "lucide-react"
import { motion } from "motion/react"

import { useSmoothScroll } from "@/hooks/use-smooth-scroll"
import { buttonVariants } from "@/components/ui/button"
import { ScrollReveal } from "@/components/scroll-reveal"

export function CtaSection() {
  const handleSmoothScroll = useSmoothScroll()

  return (
    <section className="pb-20 sm:pb-28">
      <div className="bg-muted/60 rounded-2xl border px-6 py-10 sm:px-10 sm:py-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="space-y-4">
            <ScrollReveal y={12}>
              <div className="text-primary inline-flex items-center gap-2 text-sm font-medium">
                <Sparkles className="h-3.5 w-3.5" />
                Ready when you are
              </div>
            </ScrollReveal>
            <div className="space-y-3">
              <ScrollReveal delay={0.06} y={16}>
                <h2 className="max-w-2xl text-3xl leading-tight font-semibold tracking-tight sm:text-4xl">
                  Ship production-ready snippets faster
                </h2>
              </ScrollReveal>
              <ScrollReveal delay={0.12} y={16}>
                <p className="text-muted-foreground max-w-2xl text-base sm:text-lg">
                  Generate with live preview, validation, and filename guidance
                  so your team never has to guess formats again.
                </p>
              </ScrollReveal>
            </div>
          </div>
          <ScrollReveal
            delay={0.18}
            y={16}
            className="flex flex-col gap-3 sm:flex-row"
          >
            <Link
              href="/generate"
              className={buttonVariants({
                variant: "default",
                size: "lg",
                className:
                  "shadow-[0_0_28px_color-mix(in_oklab,var(--primary)_60%,transparent)] transition-[color,background-color,box-shadow,transform] hover:-translate-y-0.5 hover:shadow-[0_0_40px_color-mix(in_oklab,var(--primary)_80%,transparent)]",
              })}
            >
              Open generator
              <ArrowRight className="h-4 w-4" />
            </Link>
            <motion.button
              type="button"
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSmoothScroll("features")}
              aria-label="View features"
              className={buttonVariants({
                variant: "outline",
                size: "lg",
              })}
            >
              View features
            </motion.button>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
